import React, { useEffect, useState } from 'react'
import EventHeader from './EventHeader'
import { useNavigate } from 'react-router-dom'
// import './../../assets/events.css'
import { useDispatch, useSelector } from 'react-redux';
import { getEventsFetchData } from '../../../redux/actions/getEventAction';
import { eventbaseurlforimages } from '../../../utils/httpService';

const AllEvents = () => {
  const navigate = useNavigate()
  const [eventsData, setEventsData] = useState([]);
  const dispatch = useDispatch();
  const eventsFromRedux = useSelector((state) => state.getEventReducer?.data); 
const baseurlforimages = eventbaseurlforimages
  useEffect(() => {
    dispatch(getEventsFetchData());
  }, [dispatch]);

  useEffect(() => {
    if (eventsFromRedux?.events) {
      setEventsData(eventsFromRedux.events);
    }
  }, [eventsFromRedux]);
  const [expandedEvents, setExpandedEvents] = useState({});

  function stripHtml(html) {
    const tmp = document.createElement("DIV");
    tmp.innerHTML = html;
    return tmp.textContent || tmp.innerText || "";
  }
  const toggleReadMore = (eventId) => {
    setExpandedEvents((prev) => ({
      ...prev,
      [eventId]: !prev[eventId],
    }));
  };
  return (
    <div className='event-container'>
      <EventHeader />
      <div className="container py-5">
        <div className="d-flex justify-content-between align-items-center mb-4">
          <h2 className="fw-bold mb-4">All Events</h2>
          <div className="breadcrumb" style={{backgroundColor: 'white'}}>
            <li className="breadcrumb-item">
              <a onClick={() => navigate("/event")}>Home</a>
            </li>
            <li className="breadcrumb-item active">All Events</li>
          </div>
        </div>
        <div className="row g-4">
          {eventsData && eventsData.length > 0 ? (
            eventsData.map((event, index) => (
              <div key={index} className="col-md-4" onClick={() => navigate(`/event-detail/${event._id}`)} style={{ cursor: 'pointer' }}>
                <a className="text-decoration-none text-dark">
                  <div className="card shadow-sm h-100">
                  <img
                  
                  src={`${baseurlforimages}${event?.media[0]?.url}`}
                className="card-img-top event-img-card-img"
                onClick={()=> console.log(` "Check the image url ${baseurlforimages}  + ${event.media[0].url}`)}
                alt="..."
                />
                    <div className="card-body">
                      <h5 className="card-title">{event.title}</h5>


                      <p className="card-text text-muted">
                    {expandedEvents[event._id]
                      ? <span dangerouslySetInnerHTML={{ __html: event.description }} />
                      : (
                          stripHtml(event.description).length > 100
                            ? stripHtml(event.description).slice(0, 100) + "..."
                            : stripHtml(event.description)
                        )
                    }
                  </p>
                  {/* Show Read More/Less only if description is long */}
                  {stripHtml(event.description).length > 100 && (
                    <span
                      onClick={e => {
                        e.stopPropagation(); // Prevent card click
                        toggleReadMore(event._id);
                      }}
                      style={{ color: "red", cursor: "pointer" }}
                    >
                      {expandedEvents[event._id] ? "Read Less" : "Read More"}
                    </span>
                  )}


                      {/* <p className="card-text text-muted">
                        {event.description}
                      </p> */}
                    </div>
                  </div>
                </a>
              </div>
            ))
          ) : (
            <div className="col-12 text-center">
              <p>No events found</p>
            </div>
          )}
        </div>
      </div>
    </div>
  )
}

export default AllEvents
